import { ArrowRight, BellRing, Radar } from "lucide-react";
import { appUrl, features, renewalRows } from "./content";

function ProductPreview() {
  return (
    <section className="productPreview" aria-label="SubLeak product preview">
      <div className="previewHeader">
        <span>Renewal risk</span>
        <BellRing size={20} aria-hidden="true" />
      </div>
      <p className="previewMetric">12,480 THB</p>
      <p className="previewCaption">Recurring spend due in the next 7 days</p>

      <div className="renewalTable" role="table" aria-label="Upcoming renewal examples">
        {renewalRows.map((row) => (
          <div className="renewalRow" role="row" key={row.name}>
            <div role="cell">
              <strong>{row.name}</strong>
              <small>{row.group}</small>
            </div>
            <span role="cell">{row.amount}</span>
            <em role="cell">{row.due}</em>
          </div>
        ))}
      </div>
    </section>
  );
}

function FeatureBand() {
  return (
    <section className="featureBand" aria-label="Core features">
      {features.map((feature) => (
        <article key={feature.title}>
          <feature.icon aria-hidden="true" />
          <h2>{feature.title}</h2>
          <p>{feature.copy}</p>
        </article>
      ))}
    </section>
  );
}

export default function App() {
  return (
    <main>
      <section className="hero" aria-labelledby="hero-title">
        <nav className="nav" aria-label="Main navigation">
          <a className="brand" href="/" aria-label="SubLeak home">
            <span className="brandMark" aria-hidden="true">
              <Radar size={18} strokeWidth={2.4} />
            </span>
            <span>SubLeak</span>
          </a>
          <a className="navLink" href={`${appUrl}/login`}>
            Sign in
          </a>
        </nav>

        <div className="heroGrid">
          <div className="heroCopy">
            <p className="eyebrow">Subscription cost leak detector</p>
            <h1 id="hero-title">Stop forgotten renewals from leaking cash.</h1>
            <p className="lede">
              Track subscriptions, provider accounts, renewal dates, and Telegram alerts in one quiet workspace
              built for recurring spend that hides across tools.
            </p>
            <div className="actions" aria-label="Primary actions">
              <a className="primaryCta" href={`${appUrl}/register`}>
                Start tracking <ArrowRight size={18} aria-hidden="true" />
              </a>
              <a className="secondaryCta" href={`${appUrl}/login`}>
                Open web app
              </a>
            </div>
          </div>

          <ProductPreview />
        </div>
      </section>

      <FeatureBand />
    </main>
  );
}
